<template>
  <Form
    :error="error"
    :error-text="error"
    @submit="submit"
    class="login-form"
  >
    <Formcell
      v-model="email"
      id="email"
      label="Email"
      type="email"
      required
    />

    <Formcell
      v-model="pass"
      id="pass"
      type="password"
      required
    >
      <div class="label-link">
        <label for="pass" class="label lable-mb0">Пароль</label>
        <router-link :to="{name: 'forgot'}" class="link link-12">Забыли пароль?</router-link>
      </div>
    </Formcell>

    <Submit :loading="isLoading" text="Войти в сервис" />
  </Form>
</template>

<script>
  import {mapState, mapActions} from 'vuex';
  import Formcell from '@/components/Formcell';
  import Submit from '@/components/Submit';
  import {required, minLength, email} from 'vuelidate/lib/validators';
  import Form from '@/components/Form';

  export default {
    name: 'LoginForm',
    components: {Form, Submit, Formcell},
    data () {
      return {
        email: '',
        pass: '',
      };
    },
    validations: {
      email: {required, email},
      pass: {required, minLength: minLength(6)},
    },
    computed: mapState({
      isLoading: state => state.auth.isLoading,
      error: state => state.auth.error,
    }),
    methods: {
      ...mapActions({
        login: 'auth/login',
        changeError: 'auth/changeError',
      }),
      async submit () {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.changeError('Пожалуйста, заполните все поля.');
          return;
        }

        try {
          await this.login({email: this.email, password: this.pass});
          await this.$router.push({name: 'home'});
        } catch (e) {
          this.changeError('Не удалось войти.');
        }
      },
    },
  };
</script>
